/* eslint-disable react/no-danger */
import React from 'react';
import { useSelector } from 'react-redux';

import {
  GoogleAnalyticsConstants,
  GoogleAnalyticsDisplayedEvent,
  GoogleAnalyticsEventContextWrapper,
} from '@vvoyages/google-analytics';
import DOMPurify from 'isomorphic-dompurify';

import Button from '@/components/Button';
import ExternalLink from '@/components/ExternalLink/ExternalLink';
import { WizardStep } from '@/components/Wizard';
import { CONTACT_US_URL } from '@/constants';
import { appUiIds } from '@/constants/appUiIds';
import useAppUiData from '@/hooks/useAppUiData';
import { selectResources } from '@/reducers/common/selectors';

import styles from './ClaimBookingStep.module.scss';

type ClaimImportingInProgressProps = {
  tabId: string;
  reloadReservation: Function;
};

const ClaimImportingInProgress: React.FC<ClaimImportingInProgressProps> = ({ tabId, reloadReservation }) => {
  const appUiData = useAppUiData();
  const resources = useSelector(selectResources);
  return (
    <WizardStep tabId={tabId}>
      <GoogleAnalyticsEventContextWrapper category="VV-account-sign-in|importation-delayed-state">
        <GoogleAnalyticsDisplayedEvent eventAction={GoogleAnalyticsConstants.EVENT_ACTION.DISPLAYED} />
        <h2 className={styles.title}>{appUiData[appUiIds.claimBooking.title]}</h2>
        <p className={styles.subtitleMain}>{appUiData[appUiIds.importation.importing]}</p>
        <p
          className={styles.subtitle}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(appUiData[appUiIds.importation.tryReloadingText]) }}
        />
        <Button variant="primary" onClick={reloadReservation} className={styles.buttonReloadReservation}>
          {appUiData[appUiIds.importation.reloadReservation]}
        </Button>
        <div className={styles.linkContainer}>
          <ExternalLink href={resources[CONTACT_US_URL]} name={appUiData[appUiIds.sailorServices]} />
        </div>
      </GoogleAnalyticsEventContextWrapper>
    </WizardStep>
  );
};

export default ClaimImportingInProgress;
